import { LatLng } from './types';

/**
 * Open the full building page in a new tab via the deep-link contract
 * (`?building-id=ID&lat=LAT&lng=LNG`). Shared by the explore panel cards, the
 * desktop preview card, and the Activity row detail header, so the query-param
 * contract lives in exactly one place.
 */
export const openBuildingInNewTab = (buildingId: string, coords?: LatLng) => {
  const url = new URL(window.location.origin);
  url.searchParams.set('building-id', buildingId);
  if (coords) {
    url.searchParams.set('lat', String(coords.lat));
    url.searchParams.set('lng', String(coords.lng));
  }
  window.open(url.toString(), '_blank', 'noopener');
};
